import { useCallback, useState } from "react";

import {
  combineRunProps,
  type OverrideRunProps,
  useRequestWithFeedback,
} from "../../../composites";
import { useObjectMemo } from "../../../hooks";

import { API } from "./api";

import type { OrganizationUsersPayload } from "../../../../types/models/v1";

export const useFetchOrganizationUsers = (orgId: API.OrganizationId) => {
  const { send, loading, status } =
    useRequestWithFeedback<OrganizationUsersPayload>();
  const [data, setData] = useState<API.OrganizationUser[] | null>(null);

  const fetchOrganizationUsers = useCallback(
    (overrideRunProps: OverrideRunProps) => {
      send({
        action: API.fetchOrganizationUsers(orgId),
        ...combineRunProps(
          {
            onData: ({ organization_users: orgUsers }) => {
              setData(orgUsers as API.OrganizationUser[]);
            },
          },
          overrideRunProps,
        ),
      });
    },
    [send, orgId],
  );

  return useObjectMemo({
    data,
    error: status === "error",
    send: fetchOrganizationUsers,
    loading,
  });
};
